import english from './lang/en.json'
import persian from './lang/fa.json'
import arabic from './lang/ar.json'

export default {
  en: english,
  fa: persian,
  ar: arabic
}
